import React from 'react';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { CREATE_REQUEST, SEND_FROM } from 'apps/auth/constants/Constants';
import { ACCOUNT_TO, CARD_EXP_DATE, FROM_ACCOUNT, SOURCE_CARD_CVV, SOURCE_CARD_EXP_DATE } from 'apps/auth/constants/fieldsName';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import NewCardField from '../form/NewCardField';

const NewCardScreen = (props) => {
    const { requestCreateFromNewCardTitle, fromCardRightBlockHeader } = usePageMessages();

    return (
        <>
            <HeaderPanel title={requestCreateFromNewCardTitle} subtitle={fromCardRightBlockHeader} />
            <Row indent="adaptive-32-48">
                <NewCardField
                    binExtraName="binInfo"
                    formName={props.formName}
                    countryA2From={props.fromCountry?.code}
                    countryA2To={props.toCountry?.code}
                    actionType={props.isCreate ? CREATE_REQUEST : SEND_FROM}
                    panName={props.isCreate ? ACCOUNT_TO : FROM_ACCOUNT}
                    expiredDateName={props.isCreate ? CARD_EXP_DATE : SOURCE_CARD_EXP_DATE}
                    cvvName={SOURCE_CARD_CVV}
                />
            </Row>
        </>
    );
};

export default NewCardScreen;
